export enum ImportStatusType {
    Succeed = 1,
    Failed = 2,
}
